export default __webpack_public_path__ + "static/media/Fifa.66ca060a.jpg";